import { render } from "./adv_buy.vue?vue&type=template&id=cb7ef3d2&scoped=true"
import script from "./adv_buy.vue?vue&type=script&lang=js"
export * from "./adv_buy.vue?vue&type=script&lang=js"

import "./adv_buy.vue?vue&type=style&index=0&id=cb7ef3d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7ef3d2"]])

export default __exports__